// import React from 'react';
// import '../styles/Hero.css';

// function Hero() {
//   return (
//     <section id="hero" className="hero"> {/* 添加 id="hero" */}
//       {/* 左上角 YhooAI 按钮 */}
//       <a href="#hero" className="yhooai-button">yhooai</a>

//       {/* ナビゲーションリンク */}
//       <nav className="hero-nav">
//         <a href="#profile" className="nav-button">紹介</a>
//         <a href="#skills" className="nav-button">サービス</a>
//         <a href="#projects" className="nav-button">実績</a>
//         <a href="#contact" className="nav-button">お問い合わせ</a>
//       </nav>

//       {/* Hero 内容 */}
//       <div className="hero-content">
//         <h1 className="slogan">AIと共に創造し、未来を超越する</h1>
//         <p className="slogan-sub">革新と想像力で新しい可能性を切り開きます。</p>
//       </div>

//       {/* 向下スクロールヒント */}
//       <div className="scroll-down">
//         <i className="fas fa-chevron-down"></i>
//       </div>
//     </section>
//   );
// }

// export default Hero;

import React from 'react';
import '../styles/Hero.css';

function Hero() {
  return (
    <>
      {/* 固定的顶部导航栏 */}
      <div className="hero-nav-container">
        <a href="#hero" className="yhooai-button">yhooai</a>
        <nav className="hero-nav">
          <a href="#profile" className="nav-button">紹介</a>
          <a href="#skills" className="nav-button">サービス</a>
          <a href="#projects" className="nav-button">実績</a>
          <a href="/blog/" className="nav-button">ブログ</a>
          <a href="#contact" className="nav-button">お問い合わせ</a>
        </nav>
      </div>

      {/* Hero 内容部分 */}
      <section id="hero" className="hero"> {/* 添加 id="hero" */}
        <div className="hero-content">
          <h1 className="slogan">AIと共に創造し、未来を超越する</h1>
          <p className="slogan-sub">革新と想像力で新しい可能性を切り開きます。</p>
        </div>
        <div className="scroll-down">
          <i className="fas fa-chevron-down"></i>
        </div>
      </section>
    </>
  );
}

export default Hero;
